(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches('.freefall-hero__sort-select')) return;

    var form = select.closest('.freefall-hero__sort');
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
})();
